import { createApp } from 'vue'
import App from './App.vue'

import './assets/fontawesome/css/all.css'; // Import the font awesome icons
import './styles/style.css'; // Import the global CSS file
import './styles/grid.css'; // Import the 12 col flex grid system
import './styles/gravity-forms.css';
import router from './/utils/router';

createApp(App).use(router).mount('#app')
